import { useLocation } from "react-router-dom";

import Dashboard from "./dashboard";
import Stats from "./stats";
import Map from "./map";

export function DashboardPresenter(): JSX.Element {
  const location = useLocation();

  if (location.pathname.includes("chart")) {
    return <Dashboard />;
  }
  if (location.pathname.includes("admin")) {
    return <Stats />;
  }

  return <Map />;
}
